import { defaultCountries, parseCountry } from 'react-international-phone';
import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js/mobile';
import { constants } from '../constants';
/**
 * Validates a phone number given the national number and ISO2 country code.
 * Returns null when valid, or an error message string when invalid.
 * When required=true, an empty value is also treated as an error.
 */
export const validatePhoneNumber = (value, countryCode, required) => {
    if (!value) {
        return required ? constants.settings_phone_number_required : null;
    }
    try {
        const country = defaultCountries.find((c) => c[1] === countryCode);
        if (!country)
            return constants.settings_invalid_country_selected;
        const { dialCode } = parseCountry(country);
        const fullNumber = `+${dialCode}${value}`;
        const upperCountryCode = countryCode.toUpperCase();
        if (!isValidPhoneNumber(fullNumber, upperCountryCode)) {
            try {
                const phoneNumberObj = parsePhoneNumber(fullNumber, upperCountryCode);
                if (!phoneNumberObj) {
                    return constants.settings_invalid_phone_number(country[0]);
                }
                if (!phoneNumberObj.isValid()) {
                    return constants.settings_invalid_phone_number_format(country[0]);
                }
            }
            catch {
                return constants.settings_invalid_phone_number(country[0]);
            }
            return constants.settings_invalid_phone_number(country[0]);
        }
        return null;
    }
    catch (error) {
        console.error('Invalid phone number', error);
        return constants.settings_invalid_phone_number(countryCode);
    }
};
